/* eslint-disable */
<template>
  <PlaylistWrapper/>
</template>

<script>
import PlaylistWrapper from '../PlaylistWrapper.vue';

export default {
  name: 'course-home',
  components: {
    PlaylistWrapper,
  },
};
</script>
